import { graphql } from "@/lib/gql/__generated__";

export const HotelI18nArticleUpdate_DesignPage_Mutation = graphql(`
	mutation HotelI18nUpdate_DesignPage($input: HotelI18nArticleInput!) {
		hotelI18nArticleUpdate(input: $input) {
			userErrors
			hotelI18n {
				id
				lang
				companyID
				hotelID
				name
				catchCopy
				address {
					nationality
					postalCode
					state
					pref
					city
					town
					other
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
			}
		}
	}
`);
